module.exports = __webpack_public_path__ + "static/media/science_tailored_phone.86d1754b.png";